const CONVERSATION_MENU_VIEWS = ['all', 'mine', 'archived'];
const WORKFLOW_CONVERSATION_VIEWS = ['all', 'mine', 'mine_archived'];

const DEFAULT_FILTER_BY_VIEW = {
  all: 'all',
  mine: 'mine',
  archived: 'archived',
};

const FILTER_TITLE_KEYS = {
  all: 'CHAT_LIST.ASSIGNEE_TYPE_TABS.all',
  mine: 'CHAT_LIST.ASSIGNEE_TYPE_TABS.me',
  unread: 'CHAT_LIST.CONVERSATION_MENU_FILTERS.unread',
  unreplied: 'CHAT_LIST.CONVERSATION_MENU_FILTERS.unreplied',
  read: 'CHAT_LIST.CONVERSATION_MENU_FILTERS.read',
  mention: 'CHAT_LIST.CONVERSATION_MENU_FILTERS.mention',
  archived: 'CHAT_LIST.CONVERSATION_MENU_FILTERS.archived',
};

export const isConversationMenuView = conversationView => {
  return CONVERSATION_MENU_VIEWS.includes(conversationView);
};

export const isWorkflowConversationView = conversationView => {
  return WORKFLOW_CONVERSATION_VIEWS.includes(conversationView);
};

const shouldUseAllConversationAssigneeType = ({
  currentUserRole,
  userPermissions = [],
}) => {
  return (
    ['administrator', 'agent'].includes(currentUserRole) ||
    userPermissions.includes('conversation_manage')
  );
};

export const getConversationMenuAssigneeType = ({
  conversationView,
  currentUserRole,
  userPermissions = [],
}) => {
  if (conversationView === 'mine') {
    return 'me';
  }

  if (['all', 'archived'].includes(conversationView)) {
    return shouldUseAllConversationAssigneeType({
      currentUserRole,
      userPermissions,
    })
      ? 'all'
      : 'mine_unassigned';
  }

  return null;
};

export const getConversationMenuDefaultStatus = conversationView => {
  return conversationView === 'archived' ? 'resolved' : 'open';
};

export const getConversationMenuFilterOptions = ({ conversationView, t }) => {
  const defaultValue = DEFAULT_FILTER_BY_VIEW[conversationView];
  if (!defaultValue) return [];

  return [
    {
      label: t(FILTER_TITLE_KEYS[defaultValue]),
      value: defaultValue,
    },
    {
      label: t(FILTER_TITLE_KEYS.unread),
      value: 'unread',
    },
    {
      label: t(FILTER_TITLE_KEYS.unreplied),
      value: 'unreplied',
    },
    {
      label: t(FILTER_TITLE_KEYS.read),
      value: 'read',
    },
    {
      label: t(FILTER_TITLE_KEYS.mention),
      value: 'mention',
    },
    {
      label: t(FILTER_TITLE_KEYS.archived),
      value: 'archived',
    },
  ];
};

export const getConversationMenuFilterTitle = ({
  conversationView,
  currentFilter,
  t,
}) => {
  const defaultFilter = DEFAULT_FILTER_BY_VIEW[conversationView];
  return t(FILTER_TITLE_KEYS[currentFilter || defaultFilter]);
};

export const getConversationMenuFilterStatus = currentFilter => {
  return currentFilter === 'archived' ? 'resolved' : 'open';
};

export const getConversationMenuFilterConversationType = currentFilter => {
  if (currentFilter === 'mention') return 'mention';
  if (currentFilter === 'unreplied') return 'unattended';
  return '';
};

export const getConversationMenuUnreadFilter = currentFilter => {
  if (['unread', 'read'].includes(currentFilter)) {
    return currentFilter;
  }

  return null;
};

export const normalizeConversationMenuFilterForStatus = ({
  conversationView,
  status,
}) => {
  if (status === 'resolved') {
    return 'archived';
  }

  return DEFAULT_FILTER_BY_VIEW[conversationView];
};

export const shouldShowConversationMenuDropdown = conversationView => {
  return ['all', 'mine'].includes(conversationView);
};

export const shouldShowConversationStatusFilter = conversationView => {
  return conversationView !== 'archived';
};

export const getWorkflowConversationAssigneeType = ({
  conversationView,
  currentUserRole,
  userPermissions = [],
}) => {
  if (['mine', 'mine_archived'].includes(conversationView)) {
    return 'me';
  }

  if (conversationView === 'all') {
    return shouldUseAllConversationAssigneeType({
      currentUserRole,
      userPermissions,
    })
      ? 'all'
      : 'mine_unassigned';
  }

  return null;
};

export const getWorkflowConversationStatus = conversationView => {
  return conversationView === 'mine_archived' ? 'resolved' : 'unresolved';
};
